import type { TranslationTemplate } from "../../../application.i18n";

export default {
	unit: {
		unknown: "ukjent",
		g: "g",
		"g/s": "g/s",
		m: "m",
		celsius: "°C",
		per_mille: "‰",
		"mg/l": "mg/l",
		"cm/s": "cm/s",
		"umol/l": "µmol/l",
		sea_current_direction: "°M",
		pellets: "pellets",
		kg: "kg",
		tn: "tn",
		percent: "%",
		"kg/m": "kg/m",
		temperature: "°C",
		length: "m",
		umol: "µmol",
		noUnit: "",
		"m/s": "m/s",
		psu: "PSU",
		PSU: "PSU",
		rpm: "RPM",
		hz: "Hz",
		bar: "Bar",
		seconds: "sek",
		degrees: "°",
		"km/m3": "km/m³",
		"n/m3": "n/m³",
		pfm: "PFM",
	},
	unitWithValue: {
		unknown: "{{}}",
		g: "{{value}} g",
		"g/s": "{{value}} g/s",
		m: "{{value}} m",
		celsius: "{{value}} °C",
		per_mille: "{{value}} ‰",
		"mg/l": "{{value}} mg/l",
		"cm/s": "{{value}} cm/s",
		"umol/l": "{{value}} µmol/l",
		sea_current_direction: "{{value}} °M",
		pellets: "{{value}} pellets",
		kg: "{{value}} kg",
		tn: "{{value}} tn",
		percent: "{{value}} %",
		"kg/m": "{{value}} kg/m",
		temperature: "{{value}} °C",
		length: "{{value}} m",
		umol: "{{value}} µmol",
		noUnit: "",
		"m/s": "{{value}} m/s",
		psu: "{{value}} PSU",
		PSU: "{{value}} PSU",
	},
	date: {
		date_time: "dd.LL.yyyy HH:mm",
		date_hours: "d LLL HH:mm",
		weekday_date_short_month_year: "EEEE dd.LLL.yyyy",
		date: "dd.LL.yyyy",
		time: "HH:mm",
		day_month: "dd.LLL",
	},
	duration: {
		minutes: "m 'minutter'",
		minutes_seconds: "m 'min' s 'sek'",
		hours: "h 'timer'",
		hours_minutes: "h 't' m 'min'",
		hours_minutes_seconds: "h 't' m 'min' s 'sek'",
		days: "d 'dager'",
		days_hours: "d 'dager' h",
		days_hours_minutes: "d 'dager' h't' m'm'",
		days_hours_minutes_seconds: "d 'dager' h't' m'm' s's'",
	},
	"duration-fmt": {
		minutes: "m 'minutter'",
		hours: "h 'timer'",
		"hours-minutes": "h 't' m 'm'",
		"hours-minutes-seconds": "h 't' m 'm' s 's'",
		days: "d 'dager'",
		"days-hours": "d 'dager' h",
		"days-hours-minutes": "d 'dager' h't' m'm'",
		"days-hours-minutes-seconds": "d 'dager' h't' m'm' s's'",
	},
} satisfies TranslationTemplate["FORMAT"];
